module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGGyumaoM-5da60611062ff407f65b494b59f00d45.png";